
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0217"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0217"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7zysn", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $583687ab3f2bcfd7$export$6503ec6e8aabbaf; }, function (v) { return $583687ab3f2bcfd7$export$6503ec6e8aabbaf = v; });
var $583687ab3f2bcfd7$export$6503ec6e8aabbaf;
var $583687ab3f2bcfd7$export$f7ad0328861e2f03;
"use strict";
var $583687ab3f2bcfd7$var$mapping = new Map();
function $583687ab3f2bcfd7$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$583687ab3f2bcfd7$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $583687ab3f2bcfd7$var$resolve(id) {
    var resolved = $583687ab3f2bcfd7$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$583687ab3f2bcfd7$export$6503ec6e8aabbaf = $583687ab3f2bcfd7$var$register;
$583687ab3f2bcfd7$export$f7ad0328861e2f03 = $583687ab3f2bcfd7$var$resolve;

});

var $499b7a52da7db431$exports = {};

(parcelRequire("7zysn")).register(new URL("", import.meta.url).toString(), JSON.parse('["bwtDg","index.0141047e.js","5KD4M","uwu_plain.89c01b2b.svg"]'));


//# sourceMappingURL=index.runtime.ec1cfa34.js.map
